import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Grid, Typography, Stack, debounce, Button, Dialog, DialogContent } from "@mui/material";
import CustomTextField from "../commoncomponents/CustomTextField";
import ComponentHeader from "../commoncomponents/ComponentHeader";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import CustomDateTimePicker from "../commoncomponents/CustomDateTimePicker";
import CustomTextArea from "../commoncomponents/CustomTextArea";
import { useDispatch, useSelector } from "react-redux";
import { getAuthToken, getCreatedBy } from "../../utility/tokenUtility";
import { updateWorkOrderStatus } from "../../redux/actions/ScmActionTypes";
import { useLocation } from "react-router-dom";
import ScmRepositry from "../../api/repositories/scmRepository";
import ScmBottomButtonsforWorkOrder from "./ScmBottomButtonsforWorkOrder";
import { mandatoryFields } from "../../redux/actions/assetActions";
import PageLoader from "../commoncomponents/PageLoader";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import axios from "axios";
import CustomDialog from "../commoncomponents/CustomDialog";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import CustomTooltip from "../commoncomponents/CustomTooltip";
import { format, isValid, parseISO } from "date-fns";
import ScmSignatureGrid from "./ScmSignatureGrid";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import { processingPercentageValue, statusList } from "../../utility/message";

const ScmCompletionInfo = ({ setPage, page, buttonAttributes }) => {
    const findHeaderContent = buttonAttributes.find(
        (item) => item.currentPageName === page
    );
    
    const dispatch = useDispatch();
    const location = useLocation();
    const basicDetails = useSelector((state) => state.scmBasicDetails);
    const completionInfoMandatoryFields = useSelector((state) => state.workOrdermandatoryFields.completionInfoMandatoryFields);
    const status = useSelector((state) => state?.workOrderStatus?.status);
    const assetCategoryType = useSelector((state) => state?.serviceType);
    const viewmode = location.state?.viewmode;
    const setOutsourceDetails = basicDetails?.vendorField;
    const completionInfo = basicDetails?.completionInfo || {};
    const costInfo = basicDetails?.completionInfo?.costInfo || {};
    const respondedBy = basicDetails?.assessments?.respondedBy?.label || "";
    const designation = basicDetails?.assessments?.designation || ""
    const getRespondStartDateandTime = basicDetails?.assessments?.respondedStartDateandTime || "";
    const getRespondEndDateandTime = basicDetails?.assessments?.respondedEndDateandTime || "";
    const repairTrackerTimes = basicDetails?.assessments?.repairTracker || [];
    const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    const workorderDateTime = basicDetails?.workorderDateandTime || "";
    

    const [completionInfoData, setCompletionInfoData] = useState(completionInfo || {});
    const [loading,setLoading] = useState(false);
    const [errorDialog,setErrorDialog] = useState(false);
    const [errorDialogMssg,setErrorDialogMssg] = useState("");
    const [gridApi, setGridApi] = useState(null);
    const [option, setOption] = useState({
        respondedBy: [],
    });

    const [error, setError] = useState({
        respondedDateandTime: false,
        completionBy: false,
        actionTaken: false,
    });

    const [errorMessage, setErrorMessage] = useState({
        respondedDateandTime: "",
        completionBy: "",
        actionTaken: "",
    });
    const [signatureDeleteDialog, setSignatureDeleteDialog] = useState(false);
    const [signatureId, setSignatureId] = useState(null);
    const [signatureDialog, setsignatureDialog] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [getByIdSignatures, setGetByIdSignatures] = useState([]);
    const [isSignatureAffected, setIsSignatureAffected] = useState(false);
    const [signatureMandatory,setSignatureMandatory] = useState(false)
    const [signatureRows, setSignatureRows] = useState([
        {
          id: 1,
          category: '',
          fileType: '',
          designation: '',
          size: '',
        }
      ]);  
      

    const statusMapping = {
        "Open": 1,
        "In Progress": 3,
        "Completed": 4,
        "Closed": 5,
        "Cancelled": 6,
        "Verified": 8,
        "Not Done and Closed":7,
        "Completed-Outsource":9,
        "In Progress-Outsource":10
    };

    // Map the current status to the corresponding number
    const mappedStatus = statusMapping[status] || null; // If status doesn't exist, fallback to null or any default value 


    function AddRowButton(props) {
        const handleClick = () => {
          props.onClick();
        };
    
        return (
    
          <Box sx={{ mb: 1 }}>
    
            <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={handleClick} >
              Add Row
            </Button>
          </Box>
        );
      };


      let getFirstIndexofStartDateTime;
      let getLastIndexofEndDateTime;
   
      if (repairTrackerTimes.length === 1) {
        getFirstIndexofStartDateTime = repairTrackerTimes[0]?.startDateandTime || "";
        getLastIndexofEndDateTime = repairTrackerTimes[0]?.endDateandTime || "";
      } else if (repairTrackerTimes.length > 1) {
        getFirstIndexofStartDateTime = repairTrackerTimes.reduce((earliest, current) => {
        return new Date(earliest.startDateandTime) < new Date(current.startDateandTime) ? earliest : current;
        }).startDateandTime || "";
        // Find the row with the greatest endDateandTime
        getLastIndexofEndDateTime = repairTrackerTimes.reduce((latest, current) => {
        return new Date(latest.endDateandTime) > new Date(current.endDateandTime) ? latest : current;
        }).endDateandTime || "";
     
        getLastIndexofEndDateTime = getLastIndexofEndDateTime || "";
      };
   
    //To calculate Downtime HRS,get the lastinderx of repairtracker end date time and workorder date time.
    let downTimeHrs = "0 Mins";
    let schdwonTimeHrs = "0 Mins";
   
    // Convert to Date objects
    const workorderDate = new Date(workorderDateTime);
    const getEndDateTime = new Date(getLastIndexofEndDateTime);
    const getStartDateTime = new Date(getFirstIndexofStartDateTime);
   
    if (!isNaN(workorderDate.getTime()) && !isNaN(getEndDateTime.getTime() && !isNaN(getStartDateTime.getTime()))) {  
      // Calculate duration only if both dates are valid
      const timeDifference = Math.abs(getEndDateTime - workorderDate);
      const scheduleDifference = Math.abs(getEndDateTime - getStartDateTime);
      const scheduletotalMinutes = Math.floor(scheduleDifference / (1000 * 60)); // Convert milliseconds to minutes
      const totalMinutes = Math.floor(timeDifference / (1000 * 60)); // Convert milliseconds to minutes
   
      downTimeHrs = `${totalMinutes} Mins`;
      schdwonTimeHrs = `${scheduletotalMinutes} Mins`;
   
    };
      // Calculate the difference for Response Duration Field
      const startDate = new Date(getRespondStartDateandTime);
      const endDate = new Date(getRespondEndDateandTime);
   
      let responseDuration = "0 Mins"; // Default duration
         
      if (!isNaN(startDate) && !isNaN(endDate)) {
          // Calculate duration only if both dates are valid
          const timeDifference = Math?.abs(endDate - startDate);
          const differenceInHours = Math?.floor(timeDifference / (1000 * 60 * 60));
          const differenceInMinutes = Math?.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
          const differenceInSeconds = Math?.floor((timeDifference % (1000 * 60)) / 1000);
     
          responseDuration = `${differenceInHours?.toString()?.padStart(2, '0')}:${differenceInMinutes?.toString()?.padStart(2, '0')}:${differenceInSeconds?.toString()?.padStart(2, '0')}`;
      } else {
          responseDuration = "0 Mins";
      }


    const memoizedDetails = useMemo(() => ({
        respondedDateandTime: completionInfoData?.respondedDateandTime || '',
        completionBy: completionInfoData?.completionBy || '',
        actionTaken: completionInfoData?.actionTaken || '',

    }), [
        completionInfoData?.respondedDateandTime,
        completionInfoData?.completionBy,
        completionInfoData?.actionTaken,
    ]);

    //function to check the mandatory field are filled or not(responsible for green ticks on left side)
    const checkMandatoryValueFilled = useCallback(debounce((
        respondedDateandTime,
        completionBy,
        actionTaken
    ) => {
        const updateStatus = (type, value, name, isVisible, errorState) => ({
            type,
            valueFilled: !errorState && !!value,
            name,
            isVisible
        });
        const updateResponseDateandTime = updateStatus("Response Date & Time", respondedDateandTime, 'respondedDateandTime',true,error?.respondedDateandTime);
        const updateCompletionBy = updateStatus("Completion By", completionBy, 'completionBy',!setOutsourceDetails, error?.completionBy);
        const updateActionTaken = updateStatus("Action Taken", actionTaken, 'actionTaken',true, error?.actionTaken);
        const arrayAfterUpdating = [
            updateResponseDateandTime,
            updateActionTaken
        ];

        if (!setOutsourceDetails) {
          arrayAfterUpdating.push(updateCompletionBy)
        }

        if (arrayAfterUpdating !== undefined && arrayAfterUpdating.every(item => item !== undefined)) {
            dispatch({ type: "UPDATE_COMPLETION_INFO_MANDATORY_FIELDS", payload: arrayAfterUpdating })
        }
    }), [dispatch, error,setOutsourceDetails]);

    useEffect(() => {
        const {
            respondedDateandTime,
            completionBy,
            actionTaken,
        } = memoizedDetails;
        checkMandatoryValueFilled(
            respondedDateandTime,
            completionBy?.id || "",
            actionTaken,
        );
    }, [
        memoizedDetails,
        checkMandatoryValueFilled
    ]);

    const handleValidationForRequiredFields = () => {
        let isValid = true;
        let hasError = false;

        completionInfoMandatoryFields.map((item) => {
            if (item.valueFilled === false) {
                setError((prev) => ({
                    ...prev,
                    [item.name]: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [item.name]: `${item.type} is required `,
                }));
                isValid = false;
            }
        });

        // Check if signatureRows length is greater than 1 and there are meaningful rows
        const gridRows = signatureRows?.filter(row => row?.designation || row?.fileType || row?.size);
        if (gridRows?.length < 1) {
            hasError = true;
            setSignatureMandatory(true);
            isValid = false;
        }

        return isValid && !hasError;

};

    const handleOnchange = (value, name,errorStateName) => {

        if (name === "actionTaken") {
            if (value?.startsWith(" ")) {
                setError((prev) => ({
                    ...prev,
                    [name]: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [name]: `${errorStateName} should not start with spaces`,
                }));
                return;
            } else if (value?.endsWith("  ")) {
                setError((prev) => ({
                    ...prev,
                    [name]: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [name]: `${errorStateName} should not end with spaces`,
                }));
                return;
            } else {
                setError((prev) => ({
                    ...prev,
                    [name]: false,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [name]: "",
                }));
            }
        }

        setCompletionInfoData((previous) => {
            const updatedData = {
                ...previous,
                [name]: value,
            };

            if (name === "completionBy") {
                if (value?.id) {
                    updatedData.completionBy = { ...value, label: value?.employeename };
                } else {
                    updatedData.completionBy = "";
                };
            };

            return updatedData;
        });

        setError((prev) => {
            const updatedError = {
                ...prev,
                [name]: false
            };
            return updatedError;
        });

        setErrorMessage((prev) => ({
            ...prev,
            [name]: ''
        }));

    };

    const getEmployeeDetail = async () => {
        const respondedBy = await ScmRepositry.fetchEmployeeDetails();
        setOption((previous) => ({
            ...previous,
            respondedBy: respondedBy?.map((item, index) => ({
                key: `option${index}`,
                label: `${item?.employeecode || ""} - ${item?.employeename || ""}` || "",
                employeename: item?.employeename || "",
                designation: item?.designation || "",
                empservice: item?.empservice || "",
                id: item?.id
            }))
        }));
    };

    useEffect(() => {
        const fetchOptions = async ()=>{
			setLoading(true);
			await getEmployeeDetail();
			setLoading(false);
		};

        setCompletionInfoData((prev) => ({
            ...prev,
            startDateandTime: getFirstIndexofStartDateTime,
            endDateandTime: getLastIndexofEndDateTime,
            respondedDateandTime: getRespondStartDateandTime,
            downTimeHours: schdwonTimeHrs,
            duration: responseDuration
        }));
        if(setOutsourceDetails){
          setCompletionInfoData((prev)=>({
            ...prev,
            completionBy: { id: basicDetails?.assessments?.vendor?.id || "", label: basicDetails?.assessments?.vendor?.label || "" }
          }))
        }
        fetchOptions();
    }, [completionInfoData?.respondedBy])

    const handleSubmit = async (event) => {
        setLoading(true);
        event.preventDefault();
        const isValid = handleValidationForRequiredFields();
        let checkFieldName = serviceType === "fem" ? "Fem" : "Bem";

        const APIPayload = {
            completedbyempid: completionInfoData?.completionBy?.id || "",
            startdate: completionInfoData?.startDateandTime || "",
            enddate: completionInfoData?.endDateandTime || "",
            acceptedbyid: completionInfoData?.respondedBy?.id || "",
            isassetreqnotavail: completionInfoData?.isassetreqnotavail || false,
            actiontaken: completionInfoData?.actionTaken || "",
            downtimehours: completionInfoData?.downTimeHours || "",
            sparepartscost: costInfo?.totalSparePartCost || "",
            ppmcost: costInfo?.ppmCostByPurchaseOrder || "",
            ppmcostpurorderno: costInfo?.ppmCostByPurchaseOrder || "",
            contractppmcost: costInfo?.ppmCostByContract || "",
            contractrefno: costInfo?.contractReferenceNumber || "",
            breakdowncost: costInfo?.breakDownCost || "",
            breakdowncostpurorderno: costInfo?.poNumber || "",
            totalwocost: costInfo?.totalWorkorderCost || "",
            [`${checkFieldName}schcorrectivemaintenanceheaderId`]: basicDetails?.id || "",
            id: completionInfoData?.id || "",
            rootcause: completionInfoData?.rootCause || "",
            authorizedbyid:basicDetails?.authorizedbyid || "",
            authorizeddate:basicDetails?.AuthorizedbyDate || ""
        };

        
        if (isValid) {
            if (basicDetails?.completionInfo?.id) {
                const updCompletionInfo = await ScmRepositry.updateCompletionInfo(serviceType, completionInfoData?.id, APIPayload);
                if(updCompletionInfo?.id){
                    dispatch({ type: "CREATE_COMPLETIONINFO", payload: { ...completionInfoData, id: updCompletionInfo?.id } });
                    setPage("Cost Info");
                    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
                } else if (updCompletionInfo?.response?.data?.status >= 405){
					setErrorDialog(true);
					setErrorDialogMssg("An unexpected error occurred while processing your request.")
				  }
            }
            else {
                const saveCompletionInfo = await ScmRepositry.addCompletionInfo(serviceType, APIPayload);
                if(saveCompletionInfo?.id){
                    dispatch({ type: "CREATE_COMPLETIONINFO", payload: { ...completionInfoData, id: saveCompletionInfo?.id } });
                    dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: ( basicDetails?.assessments?.repairType === "Inhouse") ? statusList?.completed?.label : statusList?.completedOutsource?.label, percentage: processingPercentageValue?.completionInfo }));
                    setPage("Cost Info");
                    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
                } else if (saveCompletionInfo?.response?.data?.status >= 405){
					setErrorDialog(true);
					setErrorDialogMssg("An unexpected error occurred while processing your request.")
				}
            };

        }
        else if (mappedStatus === 4 || mappedStatus === 5 ) {
			if (isValid) {
				const updCompletionInfo = await ScmRepositry.updateCompletionInfo(serviceType, completionInfoData?.id, APIPayload);
				if (updCompletionInfo?.id) {
					dispatch({ type: "CREATE_COMPLETIONINFO", payload: { ...completionInfoData, id: updCompletionInfo?.id, timeStamp: updCompletionInfo?.timestamp } });
					setPage("Cost Info");
                    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
				} else if (updCompletionInfo?.response?.data?.status >= 405){
					setErrorDialog(true);
					setErrorDialogMssg("An unexpected error occurred while processing your request.")
				}
			};
		}
		else if (viewmode == true || mappedStatus === 6 || mappedStatus === 7) {
			setPage("Cost Info");
            dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
		}
        setLoading(false);
    };

    const handleCloseErrRequestDialog = () => {
		setErrorDialog(false);
		setErrorDialogMssg("");
	};
	
	const handleConfirmErrRequestDialog = (e) => {
		e.preventDefault();
		setErrorDialog(false);
		setErrorDialogMssg("")
	};


    const fetchFormData = async () => {
      let schSignatureRows = [];
      const checkFemorBem = serviceType === "fem" ? "Fem" : "Bem";

        try {
          const config = {
            headers: {
              Authorization: `Bearer ${getAuthToken('id_token')}`,
            },
          };
    
          const id = basicDetails?.id;
    
          const response = await axios.get(`${checkGraph}/api/ScheduledCorrectiveMaintenance/GetschcorrectivesignatureList/${id},1,5000`, config);
          
          if(basicDetails?.referenceWorkOrderNo?.id){
            schSignatureRows = await axios.get(`${checkGraph}/api/${checkFemorBem}unscheduledworkorder/GetscheduledsignatureList/${basicDetails?.workorderId},1,5000`, config);
          }

          const schSignatureListData = schSignatureRows?.data.map((item) => ({
            id: item?.id,
            name: item?.documenttitle || '',
            designation: item?.designation || '',
            fileType: item?.documenttype || '',
            size: item?.filesize || '',
            date: item?.signaturedate || '',
            filename: item?.filename || '',
          }));

          
          const rowsData = response?.data.map((item) => ({
            id: item?.id,
            name: item?.documenttitle || '',
            designation: item?.designation || '',
            fileType: item?.documenttype || '',
            size: item?.filesize || '',
            date: item?.signaturedate || '',
            filename: item?.filename || '',
          }));

          let mainRows = [...(rowsData || []), ...(schSignatureListData || [])];
    
          if (response?.data?.length > 0 || schSignatureListData?.length > 0) {
            setGetByIdSignatures(mainRows);
            setSignatureRows(mainRows);
          } else if (viewmode === true) {
            setSignatureRows(mainRows || []);
          }
          else {
    
            const newRow = {
              id: 1,
              category: '',
              fileType: '',
              designation: '',
              size: '',
            };
            setSignatureRows([newRow]);
          }
        } catch (error) {
          if (viewmode === true) {
    
            setSignatureRows([]);
          }
          console.log(error);
        };
      };
      useEffect(() => {
        fetchFormData();
      }, []);
    
    
    
      const handleSaveSignature = (id, data) => {
    
        // Update the row with the new signature
        const updatedRows = signatureRows.map((row) =>
          row.id === id ? { ...row, ...data, fileSignature: data.file } : row
        );
    
        setSignatureRows(updatedRows);
        fetchFormData();
        setSignatureMandatory(false);
        setsignatureDialog(false);
      };
    
    
    
      const handleSignatureDownload = async (file) => {
        try {
    
          if (file && (file instanceof Blob || file instanceof File)) {
            const url = URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = url;
            a.download = file.name ? file.name : 'signature';
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(url);
          } else {
            const id = file;
            const config = {
              headers: {
                Authorization: `Bearer ${getAuthToken('id_token')}`,
              },
            }
            const response = await axios.get(`${MasterGraph}/api/FileUpload/DownloadFile/${id}`, {
              ...config,
              responseType: 'blob'
            });
            const url = URL.createObjectURL(response.data);
            const a = document.createElement('a');
            a.href = url;
            a.download = file?.name ? file.name : 'signature';
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(url);
          }
    
        } catch (error) {
          console.error('Error downloading file:', error);
        }
    
      };
    
      useEffect(() => {
        const id = basicDetails?.id;
        if (id) {
          fetchFormData();
        }
      }, [isSignatureAffected]);
    
      const handleSignatureAddRow = () => {
        const id =
          signatureRows.length > 0
            ? Math.max(...signatureRows.map((row) => (isNaN(row.id) ? 0 : Number(row.id)))) + 1
            : 1;
        const newRow = {
          id: id,
          category: '',
          fileType: '',
          designation: '',
          size: '',
        };
        setSignatureRows((oldRows) => [...oldRows, newRow]);
      };
    
      const handleSignatureUpload = (id) => {
        setSelectedRowId(id);
        setsignatureDialog(true);
      };
    
      const handleSignatureCloseDialog = () => {
        setsignatureDialog(false);
      };
    
      const handleSignatureDeleteClick = (id) => () => {
        if (typeof id === 'string') {
          setSignatureId(id);
          setSignatureDeleteDialog(true);
        } else if (typeof id === 'number') {
          if (signatureRows.length > 1 || signatureRows?.[0]?.fileType !== '') {
            const updatedRows = signatureRows.filter((row) => row?.id !== id);
            setSignatureRows(updatedRows);
          }
        }
      };
    
      const handleConfirmSignatureDeleteClick = async () => {
        const fetchedFiles = getByIdSignatures?.find((item) => item?.id === signatureId);
        if (getByIdSignatures.length > 0 && fetchedFiles) {
          try {
            const config = {
              headers: {
                Authorization: `Bearer ${getAuthToken('id_token')}`,
              },
            }
            const response = await axios.delete(`${checkGraph}/api/${serviceType}schcorrectivecompletionsignatures/${signatureId}`, config); if (response) {
              setIsSignatureAffected(true);
              fetchFormData();
            }
          } catch (error) {
            console.log("Error deleting item:", error);
          }
        } else {
          const updatedRows = signatureRows.filter((row) => row?.id !== signatureId);
          setSignatureRows(updatedRows);
        }
        setSignatureDeleteDialog(false);
      };
    
      const handleSignatureDeleteDialogClose = () => {
        setSignatureDeleteDialog(false);
      };

        const formatDate = (dateString) => {
          if (!dateString) {
            return '';
          }
        
          try {
            let date;
            date = parseISO(dateString);
      
            if (!isValid(date)) {
              date = new Date(dateString);
            }
      
            if (!isValid(date)) {
              return 'Invalid Date';
            }
      
            const formattedDate = format(date, 'dd/MM/yyyy');
            return formattedDate;
        
          } catch (error) {
            console.error('Error parsing date:', error.message);
          }
        };

        const columns = [
          {
            field: 'signature',
            headerName: 'Signature',
            minWidth: 200,
            minWidth: 150,
            cellRenderer: (params) => (
              <Button
                variant="outlined"
                component="label"
                size="small"
                sx={{
                  width: '100px',
                  height: '38px',
                  padding: '4px 8px',
                  fontSize: '0.75rem',
                  display: 'flex',
                  justifyContent: 'center',
                }}
                onClick={() => handleSignatureUpload(params.data.id)}
                disabled={((params?.data?.file?.type || params?.data?.fileType) ? true : false) || mappedStatus === 6}
              >
                {(params?.data?.file?.type || params?.data?.fileType) ? 'Uploaded' : 'Upload'}
              </Button>
            ),
          },
          { field: 'name', headerName: 'Name', width: 150, editable: true },
          { field: 'designation', headerName: 'Designation', width: 150, editable: true },
          { field: 'fileType', headerName: 'File Type', width: 150, editable: true },
          { field: 'size', headerName: 'Size', width: 130, editable: true },
          { field: 'date', headerName: 'Date', width: 130, editable: true,valueGetter: (params) => formatDate(params?.data?.date)},
          {
            field: 'actions',
            headerName: 'Actions',
            minWidth: 160,
            cellRenderer: (params) => (
              <>
                <CustomTooltip title="Delete">
                  <Button onClick={handleSignatureDeleteClick(params?.data?.id)} disabled={viewmode || mappedStatus === 6 || ((signatureRows?.length === 1 && params?.data?.id && !params?.data?.fileType) ? true : false )}>
                    <DeleteIcon />
                  </Button>
                </CustomTooltip>
                {params?.data?.filename && (
                   <CustomTooltip title="Download">
                   <Button onClick={() => handleSignatureDownload(params?.data?.filename)} >
                     <DownloadIcon />
                   </Button>
                 </CustomTooltip>
                )}
              </>
            ),
          }
        ];
      

    return (
        <>
            <PageLoader open={loading} />
            <ComponentHeader
                mainHeader={findHeaderContent?.mainHeader}
                subHeader={findHeaderContent?.subHeader}
                secondSubHeaderAndDate={findHeaderContent?.secondSubHeaderAndDate}
				        requiredButton={viewmode ? false : findHeaderContent?.requiredButton}
            />
            <Box >
                <form onSubmit={handleSubmit} noValidate>
                    <Stack direction={'row'} alignItems={'center'} gap={1.5}>
                        <Typography m={0} variant='title2' color={'text.primary'} fontWeight={600}>{basicDetails?.schcorrectiveno || ""}</Typography>
                    </Stack>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4} sm={3}>
                            <CustomTextField
                                label="Responded By"
                                id="respondedBy"
                                name="respondedBy"
                                value={respondedBy || completionInfoData?.respondedBy || ""}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={3}>
                            <CustomTextField
                                label="Designation"
                                id="designation"
                                name="designation"
                                value={designation || completionInfoData?.designation || ""}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={6} md={4} sm={6}>
                            <CustomDateTimePicker
                                label="Respond date and Time"
                                onDateChange={(e) => handleOnchange(e, "respondedDateandTime")}
                                isMandatoryField={true}
                                value={getRespondStartDateandTime}
                                error={error?.respondedDateandTime}
                                helperText={errorMessage?.respondedDateandTime}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={2}>
                            <CustomTextField
                                label="Response Duration"
                                id="duration"
                                name="duration"
                                onChange={handleOnchange}
                                value={completionInfoData?.duration || 0}
                                disabled
                            />
                        </Grid>
                    </Grid>

                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                        <Typography variant='title2' > Completion Details</Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} sm={6}>
                                <CustomTextFieldWithSearch
                                    label="Completion By"
                                    id="completionBy"
                                    name="completionBy"
                                    onChange={handleOnchange}
                                    options={option?.respondedBy || []}
                                    value={completionInfoData?.completionBy || ""}
                                    error={error?.completionBy}
                                    errorMessage={errorMessage?.completionBy}
                                    isMandatoryField={!setOutsourceDetails}
                                    disabled={viewmode || mappedStatus === 6 || mappedStatus === 7 || setOutsourceDetails}
                                    autoFocus
                                />
                            </Grid>

                            <Grid item xs={6} md={3} sm={3}>
                                <CustomDateTimePicker
                                    label="Start date and Time"
                                    onDateChange={(e) => handleOnchange(e, "startDateandTime")}
                                    value={getFirstIndexofStartDateTime || ""}
                                    disableFutureDate={true}
                                    disabled={true}
                                    displayDefaultValue = {false}
                                />
                            </Grid>
                            <Grid item xs={6} md={3} sm={3}>
                                <CustomDateTimePicker
                                    label="End date and Time"
                                    onDateChange={(e) => handleOnchange(e, "endDateandTime")}
                                    value={getLastIndexofEndDateTime || ""}
                                    disableFutureDate={true}
                                    disabled={true}
                                    displayDefaultValue = {false}
                                />
                            </Grid>
                            <Grid item xs={6} md={3} sm={3}>
                                <CustomTextField
                                    label="Down Time Hrs"
                                    onDateChange={(e) => handleOnchange(e, "downTimeHours")}
                                    value={completionInfoData?.downTimeHours || downTimeHrs}
                                    disableFutureDate={true}
                                    disabled={true}

                                />
                            </Grid>
                        </Grid>
                    </Box>

                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                        <Typography variant='title2' >Action Taken </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={8} sm={8}>

                                <CustomTextArea
                                    label="Action Taken"
                                    id="actiontaken"
                                    onChange={(e) => handleOnchange(e, "actionTaken","Action Taken")}
                                    value={completionInfoData?.actionTaken}
                                    isMandatoryField={true}
                                    error={error?.actionTaken}
                                    helperText={errorMessage?.actionTaken}
                                    disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6}
                                    maxlength={255}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between" mb={2}>
                        <Grid >
                            <Typography variant="title2" align="left">Add Signature</Typography>
                            <Typography variant="body2" >
                            {/* Please add files in format of doc, jpg, png, pdf. */}
                            </Typography>
                        </Grid>
                        <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {!viewmode && mappedStatus !== 6 && <AddRowButton onClick={handleSignatureAddRow} />}
                        </Grid>
                        </Stack>
                        {signatureMandatory && (<Typography component={"span"} color={"error"}>
                                                                    {"Please add at least one Signature."}*
                                                                </Typography>)}
                        <CustomAgGrid
                        rows={signatureRows}
                        columns={columns}
                        setGridApi={setGridApi}
                        refSet={gridApi}
                        />

                        <Dialog open={signatureDialog} onClose={(event, reason) => {
                        if (reason !== 'backdropClick') {
                            handleSignatureCloseDialog();
                        }
                        }} >
                        <DialogContent>
                            <ScmSignatureGrid
                            onCancel={handleSignatureCloseDialog}
                            onClear={handleSignatureCloseDialog}
                            onSave={(data) => handleSaveSignature(selectedRowId, data)}
                            rowData={signatureRows.find((row) => row.id === selectedRowId)}
                            getServiceType = {serviceType}
                            />
                        </DialogContent>
                        </Dialog>
                    </Box>

                    <Box>
                        <ScmBottomButtonsforWorkOrder page={page} buttonAttributes={buttonAttributes} />
                    </Box>
                </form>
            </Box>

            <CustomDialog
                open={signatureDeleteDialog}
                onClose={handleSignatureDeleteDialogClose}
                title="Confirm Delete"
                content="Are you sure you want to delete?"
                confirmBtn="Yes"
                cancelBtn="No"
                onConfirm={handleConfirmSignatureDeleteClick}
                onCancel={handleSignatureDeleteDialogClose}
            />

            <CustomAlert
				open={errorDialog}
				onClose={handleCloseErrRequestDialog}
				onConfirm={handleConfirmErrRequestDialog}
				content={errorDialogMssg}
				confirmBtn='OK'
			/>

        </>
    );
};

export default ScmCompletionInfo;
